import * as React from "react";
import { Button } from "./Index";
import { ButtonGroup, Form, FormControl } from 'react-bootstrap';

export class FileInput extends React.Component<IFileInputProps> {
    state = { fileData: '' };

    handleClick = () => {
        this.props.uploadMethod(this.state.fileData);
    };

    handleCancel = () => {
        this.props.cancelMethod();
    };

    handleFile = e => {
        var reader = new FileReader();
        var fileByteArray = [];
        reader.readAsArrayBuffer(e.target.files[0]);
        reader.onloadend = (evt: any) => {
            if (evt.target.readyState === FileReader.DONE) {
                const arrayBuffer = evt.target.result;
                const array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                }
            }
        }

        this.setState({ ...this.state, fileData: fileByteArray });
    };

    render() {
        return (
            <Form turn-autofill-off>
                <label>Upload file:</label>
                <FormControl type="file" accept="application/pdf" onChange={this.handleFile} />
                <ButtonGroup style={{ marginTop: '15px', width: '100%' }}>
                    <Button onClick={(): void => { this.handleCancel(); }} text="Cancel" className="btn-danger" show={true} disabled={false} />
                    <Button
                        onClick={(): void => {
                            this.handleClick();
                        }}
                        show={true}
                        text="Approve"
                        className="cyan-btn"
                        disabled={!this.state.fileData}
                        style={{ float: 'right' }}
                    />
                </ButtonGroup>
            </Form>
        );
    }
}

interface IFileInputProps {
    uploadMethod: any;
    cancelMethod: any;
}
